import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import FacebookUploadCreativeAudienceFields from '../../../../../../ReusableFormFields/Audiences/FacebookAudienceFields/FacebookUploadCreativeAudienceFields'
import Step from '../../../../../../../features/components/Forms/StepForm/Step'

import { selectedPartnershipSelector } from '../../../../../../../modules/selectors/partnerships'

import {
  CUSTOM_AUDIENCES,
  CUSTOM_AUDIENCES_EXCLUSION
} from '../../../../../../ReusableFormFields/Audiences/AudiencesFields/fields'

const stepFields = [CUSTOM_AUDIENCES, CUSTOM_AUDIENCES_EXCLUSION]

const CustomAudiencesStep = ({ formik, handleStepChange }) => {
  const { t } = useTranslation()

  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const { rights_holder_name: rightsHolderName } = selectedPartnership

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step stepTitle={t(`Do you want to target ${rightsHolderName} audiences?`)} handleContinue={handleContinue}>
      <FacebookUploadCreativeAudienceFields formik={formik} />
    </Step>
  )
}

export default CustomAudiencesStep
